.error-box{border:1px solid #dc3545;border-radius:6px;background-color:#f8d7da;color:#721c24;padding:10px 15px;margin-top:10px;font-size:14px;font-weight:500;display:flex;align-items:center;gap:8px}
/*# sourceMappingURL=audit.component-4FA5XBFW.css.map */
